import { ListSubheader, MenuItem } from '@mui/material';
import type { ReactNode } from 'react';
import { EMPLOYEE_ROLE, STAFF_ROLES } from '@/api/types';
import { useCopy } from '@/hooks/useCopy';

/**
 * SASADM-0169 — the invite/add role choices for a `select`, grouped: the employee app
 * (`USER`, labelled Employee), then the admin app (Owner / Admin / Staff). Group headings
 * are `ListSubheader`s, which MUI skips for selection and arrow keys. Spread the result as
 * the select's children; call it unconditionally during render (it reads the copy catalog).
 */
export function RoleMenuItems(): ReactNode[] {
  const { t } = useCopy();
  return [
    <ListSubheader key="group-employee">
      {t('invitations.groups.employee', 'Employee app')}
    </ListSubheader>,
    <MenuItem key={EMPLOYEE_ROLE} value={EMPLOYEE_ROLE}>
      {t('members.roles.EMPLOYEE', 'Employee')}
    </MenuItem>,
    <ListSubheader key="group-admin">{t('invitations.groups.admin', 'Admin app')}</ListSubheader>,
    ...STAFF_ROLES.map((r) => (
      <MenuItem key={r} value={r}>
        {t(`members.roles.${r}`, r)}
      </MenuItem>
    )),
  ];
}
